import React, { useEffect, useMemo, useState } from 'react'
import { __DEV__ } from '@mote/helpers/constants'
import styled from '@xstyled/styled-components'
import { Block } from '../block/block'
import { CheckboxContext } from './checkbox.context'

export const CheckboxGroup = ({
  disabled = false,
  onChange,
  value = [],
  children,
  size = 'xl',
  ...rest
}) => {
  const [currentValues, setCurrentValues] = useState([])
  const providerValue = useMemo(() => {
    function updateState(value, checked) {
      const removed = currentValues.filter(v => v !== value)
      const nextValues = checked ? [...removed, value] : removed
      setCurrentValues(nextValues)
      onChange?.(nextValues)
    }

    return {
      size,
      updateState,
      disabledAll: disabled,
      inGroup: true,
      values: currentValues
    }
  }, [size, disabled, currentValues, onChange])

  useEffect(() => {
    setCurrentValues(value)
  }, [value.join(',')])

  return (
    <CheckboxContext.Provider value={providerValue}>
      <StyledCheckboxGroup role='group' gap={16} {...rest}>
        {children}
      </StyledCheckboxGroup>
    </CheckboxContext.Provider>
  )
}

if (__DEV__) {
  CheckboxGroup.displayName = 'CheckboxGroup'
}

const StyledCheckboxGroup = styled(Block)``
